export default __webpack_public_path__ + "static/abouthero-lg-01ee1d7b1d0f3f7e2908a8106b3b2268.jpg";